module.exports = __webpack_public_path__ + "static/media/app_ic_denma.04b90970.png";